import React from "react";

const S = ({ children, size = 20, fill = "none", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="block"
    {...props}
  >
    {children}
  </svg>
);

export const IconChevronLeft  = (p) => <S {...p}><path d="M15 5l-7 7 7 7" /></S>;
export const IconChevronRight = (p) => <S {...p}><path d="M9 5l7 7-7 7" /></S>;
export const IconClose        = (p) => <S {...p}><path d="M6 6l12 12M18 6L6 18" /></S>;
export const IconUndo         = (p) => <S {...p}><path d="M8 8l-4 4 4 4" /><path d="M4 12h10a5 5 0 010 10h-2" /></S>;
export const IconRedo         = (p) => <S {...p}><path d="M16 8l4 4-4 4" /><path d="M20 12H10a5 5 0 000 10h2" /></S>;

export const FlyoutMarker = ({ className = "" }) => (
  <svg width="6" height="6" viewBox="0 0 6 6" className={className} aria-hidden="true">
    <path d="M6 0v6H0z" fill="currentColor" />
  </svg>
);

export const IconSelect = (p) => (
  <S {...p} strokeWidth="1.3">
    <path d="M5.5 3.2v13.4l3.4-3.3 2.3 5.2 2.2-1-2.3-5.1h4.6z" fill="currentColor" />
  </S>
);
export const IconHand = (p) => (
  <S {...p}>
    <path d="M8.5 11V6.2a1.4 1.4 0 012.8 0V11" />
    <path d="M11.3 10.6V5.4a1.4 1.4 0 012.8 0V11" />
    <path d="M14.1 10.8V7.4a1.4 1.4 0 012.8 0V14a6 6 0 01-6 6h-.8a4.6 4.6 0 01-3.7-1.9l-2.6-3.7a1.5 1.5 0 012.3-1.9l1.4 1.5" />
  </S>
);
export const IconEraser = (p) => (
  <S {...p}><path d="M8.5 20H20" /><path d="M13 4.6l6.4 6.4L11 19.4 4.6 13z" /></S>
);
export const IconPen = (p) => (
  <S {...p}><path d="M4 20l4.2-1 9.6-9.6-3.2-3.2L5 15.8 4 20z" /><path d="M14.6 6.2l3.2 3.2" /></S>
);
export const IconHighlighter = (p) => (
  <S {...p}><path d="M5 20h6" /><path d="M9.5 15.5L6.5 18.5" /><path d="M15.4 4.6l4 4-7.6 7.6-4-4z" /></S>
);
export const IconText = (p) => (
  <S {...p}><path d="M5 6.5V4.5h14v2" /><path d="M12 4.5v15" /><path d="M9 19.5h6" /></S>
);
export const IconSquare   = (p) => <S {...p}><rect x="4.5" y="4.5" width="15" height="15" rx="1.6" /></S>;
export const IconCircle   = (p) => <S {...p}><circle cx="12" cy="12" r="7.6" /></S>;
export const IconTriangle = (p) => <S {...p}><path d="M12 4.6l7.8 14.8H4.2z" /></S>;
export const IconLine     = (p) => <S {...p}><path d="M5 19L19 5" /></S>;
export const IconArrow    = (p) => <S {...p}><path d="M5 19L19 5" /><path d="M12.5 5H19v6.5" /></S>;
export const IconImageUpload = (p) => (
  <S {...p}>
    <rect x="3.5" y="5" width="13.5" height="11.5" rx="2" />
    <path d="M4.2 14l3.4-3.4 2.9 2.9" />
    <path d="M17 21v-6.6m0 0l-2.3 2.3M17 14.4l2.3 2.3" />
  </S>
);
export const IconGrid = (p) => (
  <S {...p}>
    <rect x="4" y="4" width="6.6" height="6.6" rx="1.2" />
    <rect x="13.4" y="4" width="6.6" height="6.6" rx="1.2" />
    <rect x="4" y="13.4" width="6.6" height="6.6" rx="1.2" />
    <rect x="13.4" y="13.4" width="6.6" height="6.6" rx="1.2" />
  </S>
);
export const IconZoomIn = (p) => (
  <S {...p}><circle cx="11" cy="11" r="6.4" /><path d="M15.7 15.7L20 20" /><path d="M11 8.6v4.8M8.6 11h4.8" /></S>
);
export const IconZoomOut = (p) => (
  <S {...p}><circle cx="11" cy="11" r="6.4" /><path d="M15.7 15.7L20 20" /><path d="M8.6 11h4.8" /></S>
);
export const IconCrop = (p) => (
  <S {...p}><path d="M6.5 2.5v15h15" /><path d="M2.5 6.5h15v15" /></S>
);

export const IconBrief = (p) => (
  <S {...p}>
    <rect x="3.5" y="7.5" width="17" height="12" rx="2" />
    <path d="M9 7.5V6a2 2 0 012-2h2a2 2 0 012 2v1.5" />
  </S>
);
export const IconSmart = (p) => (
  <S {...p}><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="4.4" /><circle cx="12" cy="12" r="1.3" fill="currentColor" stroke="none" /></S>
);
export const IconSwot = (p) => (
  <S {...p}>
    <rect x="4" y="4" width="6.6" height="6.6" rx="1" />
    <rect x="13.4" y="4" width="6.6" height="6.6" rx="1" />
    <rect x="4" y="13.4" width="6.6" height="6.6" rx="1" />
    <rect x="13.4" y="13.4" width="6.6" height="6.6" rx="1" />
  </S>
);
export const IconProsCons = (p) => (
  <S {...p}><rect x="4" y="4.5" width="16" height="15" rx="1.6" /><path d="M12 4.5v15" /></S>
);
export const IconMindMap = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="2.6" />
    <circle cx="19" cy="6" r="1.8" /><circle cx="19" cy="18" r="1.8" /><circle cx="5" cy="12" r="1.8" />
    <path d="M14.1 10.4l3.2-2.9M14.1 13.6l3.2 2.9M9.4 12H6.8" />
  </S>
);
export const IconAffinity = (p) => (
  <S {...p}>
    <circle cx="8.4" cy="8.4" r="3.6" /><circle cx="15.6" cy="8.4" r="3.6" />
    <circle cx="8.4" cy="15.6" r="3.6" /><circle cx="15.6" cy="15.6" r="3.6" />
  </S>
);
export const IconFishbone = (p) => (
  <S {...p}>
    <path d="M3.5 12h17" />
    <path d="M20.5 12l-3.5-4v8z" />
    <path d="M7 8.4l2.4 3.6M7 15.6l2.4-3.6M12.4 8.4l2.4 3.6M12.4 15.6l2.4-3.6" />
  </S>
);
export const IconFiveWhys = (p) => (
  <S {...p}>
    <rect x="5" y="3.5" width="14" height="4.4" rx="1.2" />
    <rect x="5" y="16.1" width="14" height="4.4" rx="1.2" />
    <path d="M12 8.4v7.2" /><path d="M9.8 13.4L12 15.8l2.2-2.4" />
  </S>
);
export const IconKanban = (p) => (
  <S {...p}>
    <rect x="3.5" y="4.5" width="4.6" height="15" rx="1.2" />
    <rect x="9.7" y="4.5" width="4.6" height="10" rx="1.2" />
    <rect x="15.9" y="4.5" width="4.6" height="13" rx="1.2" />
  </S>
);

export const IconBarChart = (p) => (
  <S {...p}><path d="M5 20V13" /><path d="M12 20V5" /><path d="M19 20v-9" /></S>
);
export const IconLineChart = (p) => (
  <S {...p}><path d="M4 17l5-5 3.5 3.5L20 7" /><path d="M14.5 7H20v5.5" /></S>
);
export const IconPieChart = (p) => (
  <S {...p}><circle cx="12" cy="12" r="8" /><path d="M12 4v8h8" /></S>
);
export const IconTable = (p) => (
  <S {...p}><rect x="3.5" y="5" width="17" height="14" rx="1.6" /><path d="M3.5 10h17M3.5 15h17M9.8 5v14" /></S>
);
export const IconTimeline = (p) => (
  <S {...p}><path d="M4 12h16" /><circle cx="6" cy="12" r="1.9" /><circle cx="12" cy="12" r="1.9" /><circle cx="18" cy="12" r="1.9" /></S>
);
export const IconEditData = (p) => (
  <S {...p}><rect x="3.5" y="4.5" width="12" height="12" rx="1.4" /><path d="M3.5 10.5h12M9.5 4.5v12" /><path d="M14 21l5.5-5.5-2-2L12 19v2z" /></S>
);

export const IconSticker = (p) => (
  <S {...p}><path d="M12 3.8l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8z" /></S>
);
export const IconStickyNote = (p) => (
  <S {...p}><path d="M4.5 4.5h15v9.5L14 19.5H4.5z" /><path d="M19.5 14H14v5.5" /></S>
);
export const IconFrame = (p) => (
  <S {...p}><rect x="3.5" y="5.5" width="17" height="13" rx="1.4" /><rect x="6.6" y="8.4" width="10.8" height="7.2" rx="0.8" /></S>
);
export const IconTape = (p) => (
  <S {...p}><path d="M3 9.6l2.1 1.4L3 12.4l2.1 1.4L3 15.2l3.4 2.4L21 9.2 17.6 6.8z" /></S>
);
export const IconEmoji = (p) => (
  <S {...p}>
    <circle cx="12" cy="12" r="8" />
    <path d="M8.6 14.2a4.2 4.2 0 006.8 0" />
    <circle cx="9.2" cy="9.8" r="0.9" fill="currentColor" stroke="none" />
    <circle cx="14.8" cy="9.8" r="0.9" fill="currentColor" stroke="none" />
  </S>
);
export const IconConnector = (p) => (
  <S {...p}><circle cx="5.5" cy="18.5" r="2" /><path d="M7.2 17L16 8.2" /><path d="M11 6.5h7v7" /></S>
);
export const IconVisionBoard = (p) => (
  <S {...p}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="1.6" />
    <path d="M12 3.5v17M3.5 12h17" />
  </S>
);
export const IconSparkle = (p) => (
  <S {...p}>
    <path d="M12 3.2l1.9 5.1 5.1 1.9-5.1 1.9-1.9 5.1-1.9-5.1L5 10.2l5.1-1.9z" />
    <path d="M18.4 15.4l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7z" />
  </S>
);
